// Port of api/fuel/app/classes/filter/listing.php
// JS note:
// - this file intentionally stays as the closest possible port of the PHP Listing filter
// - any offline-only compromise should be explained here rather than pushed into the route files
import Filter from 'offline/filter/core/filter'
import F from 'offline/filter/constants'
import Search from 'offline/filter/core/search'
import ListingEdition from 'offline/model/listing/edition'
import DB from 'offline/db'

var LIST_TYPE_MANUAL = 2
var LIST_FREQUENCY_MONTHLY = 1
var LIST_FREQUENCY_YEARLY = 2
var LIST_FREQUENCY_ADHOC = 4

function dateAt(y, m, d, h, i, s) {
	return Math.floor(new Date(y, m, d, h || 0, i || 0, s || 0).getTime() / 1000)
}

function monthStart(timestamp) {
	var date = new Date(timestamp * 1000)
	return dateAt(date.getFullYear(), date.getMonth(), 1)
}

function monthEnd(timestamp) {
	var date = new Date(timestamp * 1000)
	return dateAt(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59)
}

function yearStart(timestamp) {
	var date = new Date(timestamp * 1000)
	return dateAt(date.getFullYear(), 0, 1)
}

function yearEnd(timestamp) {
	var date = new Date(timestamp * 1000)
	return dateAt(date.getFullYear(), 11, 31, 23, 59, 59)
}

function position(value, array) {
	var index = (array || []).indexOf(value)
	return index === -1 ? 0 : index + 1
}

function Listing(config) {
	Filter.call(this, config)
	this._filter_type = F.TYPE_GAMES
	this._cache_type = F.CACHE_LISTING
	this._result_type = F.RESULT_GAME
	this._pseudo_type = F.PSEUDO_GAME
	this._json_package = 'games'
	this._package_types = [F.PACKAGE_GAME]
}

Listing.prototype = Object.create(Filter.prototype)
Listing.prototype.constructor = Listing

Listing.prototype.template = function(data) {
	var defaults = this._config.listing.get_filter() || {}
	var sorting = false

	if (
		data &&
		defaults &&
		data.sort !== undefined &&
		defaults.sort !== undefined &&
		data.sortReverse !== undefined &&
		defaults.sortReverse !== undefined
	) {
		sorting = data.sort !== defaults.sort || data.sortReverse !== defaults.sortReverse
	}

	if (this._config.preview || sorting) {
		data = data || {}

		if (this._config.listing.get_type() !== LIST_TYPE_MANUAL) {
			if (data.sort === 'plays.context') {
				data.played = data.played || {}
				data.played.sometime = data.played.sometime || {}
				data.played.sometime.edition = true
			}
			if (data.sort === 'plays.first.context') {
				data.played = data.played || {}
				data.played.first = data.played.first || {}
				data.played.first.edition = true
			}
			if (data.sort === 'plays.last.context') {
				data.played = data.played || {}
				data.played.last = data.played.last || {}
				data.played.last.edition = true
			}
		}

		data = this._config.listing.generate_filter(this._config.edition, data)

		if (this._config.listing.get_type() === LIST_TYPE_MANUAL) {
			data.source = data.source || {}
			data.games = data.games || {}
			data.source.all = true
			data.games.subset = this._config.edition.get_indexed_games()
		}
	} else {
		data = this._config.listing.generate_filter(this._config.edition, {
			source: {
				list: this._config.edition.get_id()
			}
		})
	}

	if (!data.limit || data.limit > 1000) data.limit = 1000

	return data
}

Listing.prototype.search = function(data) {
	var filter = this._filter
	var defaults = this._config.listing.get_filter() || {}
	var sorting = false

	if (
		filter &&
		defaults &&
		filter.sort !== undefined &&
		defaults.sort !== undefined &&
		filter.sortReverse !== undefined &&
		defaults.sortReverse !== undefined
	) {
		sorting = filter.sort !== defaults.sort || filter.sortReverse !== defaults.sortReverse
	}

	if (
		!filter.source.all &&
		!filter.source.collection &&
		!filter.source.plays &&
		!filter.source.ratings &&
		!filter.source.list &&
		!filter.source['list.sorted']
	) {
		return data
	}

	if (!this._config.preview && (filter.source.list || (filter.source['list.sorted'] && !sorting))) {
		var indexed = this._config.edition.get_indexed_games()
		return {
			results: indexed,
			total: indexed.length,
			pseudo: 0,
			maximum: indexed.length,
			nested: [],
			users: this._config.users
		}
	}

	data = Search.run(this._config, this._filter, data)
	data.maximum = this._config.preview ? data.total : (this._config.edition.get_count_games() || 0)
	return data
}

Listing.prototype.package = function(data) {
	var defaultFilter = this._config.listing.get_filter() || {}
	var frequency = this._config.listing.get_frequency()
	var editionDate = this._config.edition.get_date()

	data.context = data.context || {}

	if (frequency === LIST_FREQUENCY_YEARLY) {
		data.context.plays = {
			data: {},
			from: yearStart(editionDate),
			to: yearEnd(editionDate)
		}
		data.context.edition = {
			date_end: yearEnd(editionDate)
		}
	} else if (frequency === LIST_FREQUENCY_MONTHLY) {
		data.context.plays = {
			data: {},
			from: monthStart(editionDate),
			to: monthEnd(editionDate)
		}
		data.context.edition = {
			date_end: monthEnd(editionDate)
		}
	} else if (frequency === LIST_FREQUENCY_ADHOC) {
		data.context.edition = {
			date_end: editionDate
		}
	}

	this._filter.artists = defaultFilter.artists || []
	this._filter.categories = defaultFilter.categories || []
	this._filter.designers = defaultFilter.designers || []
	this._filter.families = defaultFilter.families || []
	this._filter.languages = defaultFilter.languages || []
	this._filter.mechanics = defaultFilter.mechanics || []
	this._filter.subdomains = defaultFilter.subdomains || []
	this._filter.publishers = defaultFilter.publishers || []

	return Filter.prototype.package.call(this, data)
}

Listing.prototype.to_array = function(extra) {
	var result = Filter.prototype.to_array.call(this, extra)
	var editions = ListingEdition.filter({
		where: [['list_id', '=', this._config.listing.get_id()]],
		order: {
			list_edition_date: 'asc'
		}
	}).map(function(edition) {
		return edition.to_array()
	})

	result.editions = editions
	result.list = this._config.listing.to_array()
	result.edition = this._config.edition.to_array()
	result.stats = {
		value: String(this._config.edition.get_count_games() || 0),
		text: (this._config.edition.get_count_games() || 0) === 1 ? 'game' : 'games'
	}
	result.highlights = []
	result.pagesInclusive = this._config.inclusive ? 1 : 0

	if (this._config.listing.get_ranked()) {
		var earlierEditions = ListingEdition.filter({
			where: [['list_id', '=', this._config.listing.get_id()]],
			order: { list_edition_date: 'desc' },
			limit: 50
		}).filter(function(edition) {
			return edition.get_date() < this._config.edition.get_date()
		}, this)
		var earlierEdition = earlierEditions.length ? earlierEditions[0] : null

		if (earlierEdition) {
			var currentIndex = this._config.edition.get_indexed_games()
			var previousIndex = earlierEdition.get_indexed_games()
			var difference = currentIndex.filter(function(gameId) { return previousIndex.indexOf(gameId) === -1 })

			if (difference.length) {
				var highest = difference[0]
				result.highlights.push({
					id: highest,
					value: position(highest, currentIndex),
					movement: 0,
					type: 'Highest new entry'
				})
			}

			var previousSet = {}
			for (var i = 0; i < previousIndex.length; i++) previousSet[previousIndex[i]] = true

			var climberValue = 0
			var climberGame = 0
			var climberPosition = 0

			for (var j = 0; j < currentIndex.length; j++) {
				var gameId = currentIndex[j]
				if (!previousSet[gameId]) continue

				var currentPosition = position(gameId, currentIndex)
				var movement = position(gameId, previousIndex) - currentPosition
				if (movement > climberValue) {
					climberValue = movement
					climberGame = gameId
					climberPosition = currentPosition
				}
			}

			if (climberGame) {
				result.highlights.push({
					id: climberGame,
					value: climberPosition,
					movement: climberValue,
					type: 'Biggest climber'
				})
			}

			var knownGames = {}
			var games = (result.data && result.data.games) || []
			for (var k = 0; k < games.length; k++) knownGames[games[k].id] = true

			var missingGames = result.highlights
				.map(function(item) { return item.id })
				.filter(function(id) { return !knownGames[id] })

			if (missingGames.length) {
				var rows = DB.query('SELECT game_id, game_name FROM game WHERE game_id IN(' + missingGames.join(',') + ')')
				result.data.games = result.data.games || []
				for (var l = 0; l < rows.length; l++) {
					result.data.games.push({
						id: rows[l].game_id,
						name: rows[l].game_name
					})
				}
			}
		}
	}

	return result
}

Listing.forge = function(config) {
	return new Listing(config)
}

export default Listing
